export const dayDiff = (fromDate, toDate) => {
    return Math.abs(((fromDate.getTime() - toDate.getTime()) / (1000 * 3600 * 24)));
}